import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  TilesChoose: {
    float: 'right',
    marginBottom: 10,
    '&__boi': {
      '& > *': {
        '& > *': {
          display: 'flex',
          flexWrap: 'wrap',
        },
      },
    },
    '&__option': {
      backgroundPosition: 'center',
      border: `1px solid ${theme.palette.white}`,
      boxShadow: `0px 0px 5px 0px ${theme.palette.white}`,
      borderRadius: 3,
      color: theme.palette.white,
      cursor: 'pointer',
      display: 'inline-block',
      height: '40px',
      margin: '0 5px',
      marginBottom: 10,
      width: '40px',
      '&__dark': {
        '&--background-image': {
          backgroundImage: 'url(tiles/dark.png)',
        },
      },
      '&__expand': {
        backgroundPosition: 'center',
        cursor: 'pointer',
        display: 'inline-block',
        height: '40px',
        marginBottom: 10,
        width: '100%',
        '&__icon': {
          height: '40px',
          margin: '0 auto',
          width: '100%',
        },
      },
      '&__light': {
        '&--background-image': {
          backgroundImage: 'url(tiles/light.png)',
        },
      },
      '&__osm': {
        '&--background-image': {
          backgroundImage: 'url(tiles/blue.png)',
        },
      },
      '&__outdoor': {
        border: `1px rgb(${theme.palette.iconDivider}, 1) solid`,
        '&--background-image': {
          backgroundImage: 'url(tiles/outdoors.png)',
        },
      },
      '&__satellite': {
        '&--background-image': {
          backgroundImage: 'url(tiles/satellite.png)',
        },
      },
      '&__streets': {
        '&--background-image': {
          backgroundImage: 'url(tiles/basic.png)',
        },
      },
      '&__weather': {
        alignItems: 'center',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        marginBottom: 10,
        '&__icon': {
          height: '40px',
          width: '20px',
        },
      },
      '&--border': {
        border: `2px solid ${theme.palette.black}`,
      },
    },
    '&--min-width': {
      minWidth: 180,
    },
  },
}));

export { useStyles };
